module.exports = __webpack_public_path__ + "img/company12.2e6d9f68.png";